import { atomFamily } from "recoil";

export const isOpenState = atomFamily({
  key: "isOpen",
  default: false,
});
